export default "__VITE_ASSET__4e6bc761__"